/**
 * Magasin `meta` : petites valeurs du poste (enrolement, jeton, cle...).
 * Chaque enregistrement a la forme { key, value }.
 */
import { requestToPromise, transactionDone } from './idb';
import { STORES } from './schema';

/** Valeur d'une cle, ou undefined si elle n'existe pas. */
export async function getMeta(db, key) {
    const tx = db.transaction(STORES.META, 'readonly');
    const record = await requestToPromise(tx.objectStore(STORES.META).get(key));
    return record ? record.value : undefined;
}

/** Plusieurs cles d'un coup, dans une seule lecture : { cle: valeur | undefined }. */
export async function getMetaMany(db, keys) {
    const tx = db.transaction(STORES.META, 'readonly');
    const store = tx.objectStore(STORES.META);
    const records = await Promise.all(keys.map((key) => requestToPromise(store.get(key))));
    return Object.fromEntries(keys.map((key, i) => [key, records[i] ? records[i].value : undefined]));
}

/**
 * Ecrit plusieurs cles dans UNE transaction : tout est ecrit, ou rien.
 * @param {IDBDatabase} db
 * @param {Record<string, unknown>} entries
 */
export async function putMeta(db, entries) {
    const tx = db.transaction(STORES.META, 'readwrite');
    const store = tx.objectStore(STORES.META);
    const done = transactionDone(tx);
    try {
        for (const [key, value] of Object.entries(entries)) {
            store.put({ key, value });
        }
    } catch (error) {
        // Valeur non clonable : put() leve tout de suite, et les put() deja
        // faits seraient valides a la fin de la transaction. On l'annule.
        done.catch(() => {});
        tx.abort();
        throw error;
    }
    await done;
}
